// Hero hotels slider
document.addEventListener('DOMContentLoaded', function() {
	const slider = document.querySelector('.hero-hotels-slider');
	if (!slider) return;
	
	const grid = slider.querySelector('.hero-hotels-grid');
	const prevBtn = slider.querySelector('.hero-hotels-prev');
	const nextBtn = slider.querySelector('.hero-hotels-next');
	const dotsContainer = slider.querySelector('.hero-hotels-dots');
	const cards = Array.from(grid.querySelectorAll('.hero-hotel-card'));
	
	if (cards.length === 0) return;
	
	// currentIndex - это индекс страницы (слайда) (0, 1, 2, ...)
	let currentIndex = 0;
	let isAutoPlaying = true;
	let autoPlayInterval;
	let dots = [];
	
	// Определяем количество видимых карточек в зависимости от размера экрана
	function getVisibleCount() {
		if (window.innerWidth >= 1024) return 5;
		if (window.innerWidth >= 768) return 3;
		return 2;
	}
	
	// Вычисляем количество страниц (слайдов)
	function getTotalSlides() {
		const visibleCount = getVisibleCount();
		// Если отелей меньше или равно видимым, то страница одна
		if (cards.length <= visibleCount) return 1;
		// Иначе вычисляем количество страниц
		return Math.ceil(cards.length / visibleCount);
	}
	
	// Получаем видимые отели для текущей страницы
	function getVisibleHotels() {
		const visibleCount = getVisibleCount();
		const visible = [];
		
		// Вычисляем индекс первого отеля на текущей странице
		const startIndex = currentIndex * visibleCount;
		
		for (let i = 0; i < visibleCount; i++) {
			const index = startIndex + i;
			if (index < cards.length) {
				visible.push(cards[index]);
			}
		}
		
		return visible;
	}
	
	// Создаем точки пагинации - по одной для каждой страницы
	function createDots() {
		if (!dotsContainer) return;
		const totalSlides = getTotalSlides();
		
		// Если страница только одна, не показываем точки
		if (totalSlides <= 1) {
			dotsContainer.innerHTML = '';
			dots = [];
			return;
		}
		
		dotsContainer.innerHTML = '';
		dots = [];
		
		for (let i = 0; i < totalSlides; i++) {
			const dot = document.createElement('button');
			dot.className = 'hero-hotels-dot';
			dot.setAttribute('data-slide', i);
			dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
			dot.setAttribute('type', 'button');
			if (i === currentIndex) {
				dot.classList.add('active');
				dot.style.width = '1.5rem';
				dot.style.height = '0.5rem';
				dot.style.backgroundColor = 'white';
			} else {
				dot.style.width = '0.5rem';
				dot.style.height = '0.5rem';
				dot.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
			}
			dotsContainer.appendChild(dot);
			dots.push(dot);
		}
		
		// Добавляем обработчики событий для точек
		dots.forEach((dot, index) => {
			dot.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				isAutoPlaying = false;
				clearInterval(autoPlayInterval);
				currentIndex = index;
				updateSlider();
				// Перезапускаем автопрокрутку через 5 секунд
				setTimeout(function() {
					isAutoPlaying = true;
					startAutoPlay();
				}, 5000);
			});
		});
	}
	
	function updateSlider() {
		const visibleHotels = getVisibleHotels();
		
		// Скрываем все карточки
		cards.forEach((card) => {
			card.style.display = 'none';
		});
		
		// Показываем только видимые карточки
		visibleHotels.forEach((card) => {
				card.style.display = 'block';
		});
		
		// Обновляем точки пагинации
		if (dots.length > 0) {
			dots.forEach((dot, index) => {
				if (index === currentIndex) {
					dot.classList.add('active');
					dot.style.width = '1.5rem';
					dot.style.height = '0.5rem';
					dot.style.backgroundColor = 'white';
				} else {
					dot.classList.remove('active');
					dot.style.width = '0.5rem';
					dot.style.height = '0.5rem';
					dot.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
				}
			});
		}
	}
	
	function nextSlide() {
		const totalSlides = getTotalSlides();
		currentIndex = (currentIndex + 1) % totalSlides;
		updateSlider();
	}
	
	function prevSlide() {
		const totalSlides = getTotalSlides();
		currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
		updateSlider();
	}
	
	if (prevBtn) {
		prevBtn.addEventListener('click', function() {
			isAutoPlaying = false;
			clearInterval(autoPlayInterval);
			prevSlide();
			setTimeout(function() {
				isAutoPlaying = true;
				startAutoPlay();
			}, 5000);
		});
	}
	
	if (nextBtn) {
		nextBtn.addEventListener('click', function() {
			isAutoPlaying = false;
			clearInterval(autoPlayInterval);
			nextSlide();
			setTimeout(function() {
				isAutoPlaying = true;
				startAutoPlay();
			}, 5000);
		});
	}
	
	// Автопрокрутка
	function startAutoPlay() {
		const totalSlides = getTotalSlides();
		if (!isAutoPlaying || totalSlides <= 1) return;
		clearInterval(autoPlayInterval);
		autoPlayInterval = setInterval(function() {
				currentIndex = (currentIndex + 1) % totalSlides;
				updateSlider();
		}, 3000);
	}
	
	// Обработка изменения размера окна
	let resizeTimeout;
	window.addEventListener('resize', function() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			// Сбрасываем currentIndex если он больше количества страниц
			const totalSlides = getTotalSlides();
			if (currentIndex >= totalSlides) {
				currentIndex = 0;
			}
			createDots();
			updateSlider();
		}, 250);
	});
	
	// Остановка автопрокрутки при наведении
	slider.addEventListener('mouseenter', function() {
		isAutoPlaying = false;
		clearInterval(autoPlayInterval);
	});
	
	slider.addEventListener('mouseleave', function() {
		isAutoPlaying = true;
		startAutoPlay();
	});
	
	// Инициализация
	createDots();
	updateSlider();
	startAutoPlay();

	// Рейтинги TopHotels загружаются единым загрузчиком в Hotels.js
});

